module.exports = __webpack_public_path__ + "static/media/jingli-optimize.1d15a77f.gif";